import {
    LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_FAILURE,
    AUTO_LOGIN_BEGIN, AUTO_LOGIN_SUCCESS, AUTO_LOGIN_FAILURE,
    VERIFY_AUTH_COOKIE_BEGIN, VERIFY_AUTH_COOKIE_SUCCESS, VERIFY_AUTH_COOKIE_FAILURE,
    RECONNECT_BEGIN, RECONNECT_SUCCESS, RECONNECT_FAILURE,
    LOGOUT_BEGIN, LOGOUT_SUCCESS, LOGOUT_FAILURE,
    RECOVERY_PASSWORD_BEGIN, RECOVERY_PASSWORD_SUCCESS, RECOVERY_PASSWORD_FAILURE,
    RESET_PASSWORD_BEGIN, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE,
    SET_DARK_MODE,
    SET_DISCONNECT
} from '../constants/ActionTypes'

const initialState = {

    // Auth
    jwt: null,
    isAuthenticated: false,
    hasLoggedOut: false,

    // Login, Auto-Login
    isLoadingLogin: false,
    hasErrorLogin: null,

    // Verify Auth Cookie
    verifiedAuthCookie: null,
    isLoadingVerifyAuthCookie: false,
    hasErrorVerifyAuthCookie: null,

    // Reconnect
    isLoadingReconnect: false,
    hasErrorReconnect: null,

    // Logout 
    isLoadingLogout: false,
    hasErrorLogout: null,

    // Password Recovery
    isLoadingPasswordRecovery: false,
    wasSuccessfulPasswordRecovery: false,
    hasErrorPasswordRecovery: null,

    // Password Reset
    isLoadingPasswordReset: false,
    wasSuccessfulPasswordReset: false,
    hasErrorPasswordReset: null,

    // Theme
    darkMode: false
}

/**
 * Reducer function for handling authentication related actions.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the authentication.
 * @param {Object} action - The action object containing the type and payload.
 * @returns {Object} - The new state after applying the action.
 */
const ReducerAuth = (state = initialState, action) => {
    switch (action.type) {

        // Login and Auto-Login
        case LOGIN_BEGIN:
        case AUTO_LOGIN_BEGIN: {
            return {
                ...state,
                isAuthenticated: false,
                isLoadingLogin: true,
                hasErrorLogin: null
            }
        }
        case LOGIN_SUCCESS:
        case AUTO_LOGIN_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                jwt: action.payload.token,
                isLoadingLogin: false,
                hasErrorLogin: null,
                hasLoggedOut: false
            }
        }
        case LOGIN_FAILURE:
        case AUTO_LOGIN_FAILURE: {
            return {
                ...state,
                isAuthenticated: false,
                jwt: null,
                isLoadingLogin: false,
                hasErrorLogin: action.payload
            }
        }

        // Verify Auth Token
        case VERIFY_AUTH_COOKIE_BEGIN: {
            return {
                ...state,
                verifiedAuthCookie: null,
                isLoadingVerifyAuthCookie: true,
                hasErrorVerifyAuthCookie: null
            }
        }
        case VERIFY_AUTH_COOKIE_SUCCESS: {
            return {
                ...state,
                verifiedAuthCookie: action.payload,
                isLoadingVerifyAuthCookie: false,
                hasErrorVerifyAuthCookie: null
            }
        }
        case VERIFY_AUTH_COOKIE_FAILURE: {
            return {
                ...state,
                verifiedAuthCookie: null,
                isLoadingVerifyAuthCookie: false,
                hasErrorVerifyAuthCookie: action.payload
            }
        }

        // Reconnect
        case RECONNECT_BEGIN: {
            return {
                ...state,
                isAuthenticated: false,
                isLoadingReconnect: true,
                hasErrorReconnect: null
            }
        }
        case RECONNECT_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                jwt: action.payload.token,
                isLoadingReconnect: false,
                hasErrorLogin: null,
                hasErrorReconnect: false
            }
        }
        case RECONNECT_FAILURE: {
            return {
                ...state,
                isAuthenticated: false,
                jwt: null,
                isLoadingReconnect: false,
                hasErrorReconnect: action.payload,
                hasErrorLogin: action.payload
            }
        }

        // Disconnect
        case SET_DISCONNECT: {
            return {
                ...initialState
            }
        }

        // Logout
        case LOGOUT_BEGIN: {
            return {
                ...state,
                isLoadingLogout: true,
                hasErrorLogout: null
            }
        }
        case LOGOUT_SUCCESS: {
            return {
                ...initialState,
                hasLoggedOut: true,

                isLoadingLogout: false,
                hasErrorLogout: null
            }
        }
        case LOGOUT_FAILURE: {
            return {
                ...state,
                isLoadingLogout: false,
                hasErrorLogout: action.payload
            }
        }

        // Password Recovery
        case RECOVERY_PASSWORD_BEGIN: {
            return {
                ...state,
                isLoadingPasswordRecovery: true,
                hasErrorPasswordRecovery: null
            }
        }
        case RECOVERY_PASSWORD_SUCCESS: {
            return {
                ...state,
                wasSuccessfulPasswordRecovery: true,
                isLoadingPasswordRecovery: false,
                hasErrorPasswordRecovery: null
            }
        }
        case RECOVERY_PASSWORD_FAILURE: {
            return {
                ...state,
                wasSuccessfulPasswordRecovery: false,
                isLoadingPasswordRecovery: false,
                hasErrorPasswordRecovery: action.payload
            }
        }

        // Password Reset
        case RESET_PASSWORD_BEGIN: {
            return {
                ...state,
                isLoadingPasswordReset: true,
                hasErrorPasswordReset: null
            }
        }
        case RESET_PASSWORD_SUCCESS: {
            return {
                ...state,
                wasSuccessfulPasswordReset: true,
                isLoadingPasswordReset: false,
                hasErrorPasswordReset: null
            }
        }
        case RESET_PASSWORD_FAILURE: {
            return {
                ...state,
                wasSuccessfulPasswordReset: false,
                isLoadingPasswordReset: false,
                hasErrorPasswordReset: action.payload
            }
        }

        // Theme
        case SET_DARK_MODE: {
            return {
                ...state,
                darkMode: action.payload
            }
        }

        default: return state
    }
}

export default ReducerAuth